import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@mui/material";

export const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: "/games",
      },
    });
  };

  return (
    <Button 
    	variant="contained"
	sx={{ marginLeft: '1em', alignSelf: 'stretch' }}
    	onClick={handleLogin}>
        Bejelentkezés
    </Button>
  );
};